interface TextReadable {
  text(): Promise<string>;
}

export async function blobValidate(data: TextReadable): Promise<boolean> {
  try {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch {
    return true;
  }
}
